// Tax action constants
export const LIBRARY_TAXES_PAGE_REQUEST = 'LIBRARY_TAXES_PAGE_REQUEST';

export const LIBRARY_TAXES_LIST_REQUEST = 'LIBRARY_TAXES_LIST_REQUEST';

export const LIBRARY_TAXES_SET_LIST_TAXES = 'LIBRARY_TAXES_SET_LIST_TAXES';

export const LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS =
  'LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS';

export const LIBRARY_TAXES_SET_OUTLETS = 'LIBRARY_TAXES_SET_OUTLETS';

export const LIBRARY_TAXES_ON_CLICK_CREATE_TAX =
  'LIBRARY_TAXES_ON_CLICK_CREATE_TAX';

export const LIBRARY_TAXES_SET_CURRENT_PAGE = 'LIBRARY_TAXES_SET_CURRENT_PAGE';

export const LIBRARY_TAXES_SET_TOTAL_PAGE = 'LIBRARY_TAXES_SET_TOTAL_PAGE';

export const LIBRARY_TAXES_ON_CLICK_ROW = 'LIBRARY_TAXES_ON_CLICK_ROW';

export const LIBRARY_TAXES_SET_TAX_DETAIL = 'LIBRARY_TAXES_SET_TAX_DETAIL';

export const LIBRARY_TAXES_ON_CLICK_CANCEL = 'LIBRARY_TAXES_ON_CLICK_CANCEL';

export const LIBRARY_TAXES_SUBMIT_FORM_UPDATE =
  'LIBRARY_TAXES_SUBMIT_FORM_UPDATE';

export const LIBRARY_TAXES_SUBMIT_FORM_CREATE =
  'LIBRARY_TAXES_SUBMIT_FORM_CREATE';

export const LIBRARY_TAXES_DELETE_TAX_REQUEST =
  'LIBRARY_TAXES_DELETE_TAX_REQUEST';

export const LIBRARY_TAXES_SHOW_DELETE_MODAL =
  'LIBRARY_TAXES_SHOW_DELETE_MODAL';

export const LIBRARY_TAXES_HIDE_DELETE_MODAL =
  'LIBRARY_TAXES_HIDE_DELETE_MODAL';

export const LIBRARY_TAXES_CANCEL_DELETE = 'LIBRARY_TAXES_CANCEL_DELETE';

export const LIBRARY_TAXES_DELETE_TAX = 'LIBRARY_TAXES_DELETE_TAX';

export const LIBRARY_TAXES_SET_DELETED_TAX = 'LIBRARY_TAXES_SET_DELETED_TAX';

export const LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS =
  'LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS';

export const LIBRARY_TAXES_OPEN_RIGHT_COLUMN =
  'LIBRARY_TAXES_OPEN_RIGHT_COLUMN';

export const LIBRARY_TAXES_CLOSE_RIGHT_COLUMN =
  'LIBRARY_TAXES_CLOSE_RIGHT_COLUMN';

export const LIBRARY_TAXES_IS_SUBMITTING_FORM =
  'LIBRARY_TAXES_IS_SUBMITTING_FORM';
